import React from 'react'
import PropTypes from 'prop-types'

import { Column, Text, Wrapper } from 'Components/UI'

import isEmpty from 'lodash/isEmpty'

import { PROJECTS_DATA } from 'Constants/Projects/projectAdditionalData'

import { Container, ItemsWrapper, Plate, StyledImage } from './styles'

function Integrations({ projectId }) {
  const project = PROJECTS_DATA.find(item => item.projectId === projectId)

  if (isEmpty(project) || !project?.integrations) return null

  return (
    <Container>
      <Wrapper alignItems="flex-start" flexDirection="column">
        <Text as="h2" legacyTitle lineHeight={1} mb={4}>
          Integrations
        </Text>

        <Column fullWidth>
          {project.integrations.map(block => (
            <Column key={block.legacyTitle} mb={3}>
              <Text mb={2}>{block.title}</Text>
              <ItemsWrapper>
                {block.items.map(item => (
                  <Plate key={item.id}>
                    <StyledImage src={item.logo.src} />
                  </Plate>
                ))}
              </ItemsWrapper>
            </Column>
          ))}
        </Column>
      </Wrapper>
    </Container>
  )
}

Integrations.defaultProps = {
  projectId: '',
}

Integrations.propTypes = {
  projectId: PropTypes.string,
}

export default Integrations
